// @flow

import { makeApiCall } from '../../../../services/apiService/apiService';
import { minimumClientSearchCharacterLength } from '../../../../services/helpers';
import { toastr } from 'react-redux-toastr';

export const bulkPincodeCheckActions = {
  SET_IS_FETCHING_CLIENT_LIST: 'SET_IS_FETCHING_CLIENT_LIST',
  SET_IS_FETCHING_SERVICE_TYPE: 'SET_IS_FETCHING_SERVICE_TYPE',
  SET_CLIENT_LIST: 'SET_CLIENT_LIST',
  SET_SERVICE_TYPE: 'SET_SERVICE_TYPE',
  RESET_CLIENT_LIST_AND_FETCHING: 'RESET_CLIENT_LIST_AND_FETCHING',
  RESET_SERVICE_TYPE_AND_FETCHING: 'RESET_SERVICE_TYPE_AND_FETCHING',
  BULK_PINCODE_CHECK_CALL: 'BULK_PINCODE_CHECK_CALL'
};

export const setIsFetchingClientList = load => ({
  type: bulkPincodeCheckActions.SET_IS_FETCHING_CLIENT_LIST,
  payload: load
});

export const setIsFetchingServiceType = load => ({
  type: bulkPincodeCheckActions.SET_IS_FETCHING_SERVICE_TYPE,
  payload: load
});

export const setClientList = load => ({
  type: bulkPincodeCheckActions.SET_CLIENT_LIST,
  payload: load
});

export const setServiceType = load => ({
  type: bulkPincodeCheckActions.SET_SERVICE_TYPE,
  payload: load
});

export const resetClientListAndIsFetching = () => ({
  type: bulkPincodeCheckActions.RESET_CLIENT_LIST_AND_FETCHING
});

export const resetServiceTypeAndIsFetching = () => ({
  type: bulkPincodeCheckActions.RESET_SERVICE_TYPE_AND_FETCHING
});

export const bulkPincodeCheckCallAction = load => ({
  type: bulkPincodeCheckActions.BULK_PINCODE_CHECK_CALL,
  payload: load
});

export const getClientsList = (searchString: String) => (
  dispatch: Function
) => {
  if (
    !searchString ||
    searchString.length < minimumClientSearchCharacterLength
  ) {
    dispatch(resetClientListAndIsFetching());
    return [];
  }
  dispatch(setIsFetchingClientList(true));

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClients',
    replaceParamsArr: [
      { key: 'searchString', val: encodeURIComponent(searchString) || '' }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(setIsFetchingClientList(false));
        const responseList = res.payload || [];
        dispatch(setClientList(responseList));
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getClients call 200 failure', res);
        dispatch(resetClientListAndIsFetching());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getClients call failed ', res);
      dispatch(resetClientListAndIsFetching());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getClients call', res);
      dispatch(resetClientListAndIsFetching());
    }
  };

  return makeApiCall(requestObj);
};

export const getServiceType = (clientCode: String) => (dispatch: Function) => {
  if (clientCode) {
    dispatch(setIsFetchingServiceType(true));

    const requestObj = {
      baseUrl: 'zoomApiUrl',
      apiEndPoint: 'getServiceCategoryToServiceTypeMap',
      replaceParamsArr: [
        { key: 'clientCode', val: encodeURIComponent(clientCode) || '' }
      ],
      successCb: res => {
        if (res.status === 'SUCCESS') {
          dispatch(setIsFetchingServiceType(false));
          const defaultServiceCategoryToServiceTypeMap = { NORMAL: 'EXPRESS' };
          dispatch(
            setServiceType(
              (res.payload || {}) && Object.keys(res.payload).length > 0
                ? res.payload
                : defaultServiceCategoryToServiceTypeMap
            )
          );
        } else if (res.status === 'FAILURE') {
          // eslint-disable-next-line no-console
          console.log('getServiceTypeLane call 200 failure', res);
          dispatch(resetServiceTypeAndIsFetching());
        }
      },
      failureCb: res => {
        // eslint-disable-next-line no-console
        console.log('getServiceTypeLane call failed ', res);
        dispatch(resetServiceTypeAndIsFetching());
      },
      catchCb: res => {
        // eslint-disable-next-line no-console
        console.log('Exception in getServiceTypeLane call', res);
        dispatch(resetServiceTypeAndIsFetching());
      }
    };

    return makeApiCall(requestObj);
  }
  dispatch(resetServiceTypeAndIsFetching());
  return '';
};

export const bulkPincodeCheckCall = (obj: Object) => (dispatch: Function) => {
  dispatch(
    bulkPincodeCheckCallAction({
      bulkPincodeCheckRes: null,
      errorBulkPincodeCheck: null
    })
  );

  toastr.light('Please wait!', 'Processing..', { timeOut: 0 });

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bulkPincodeCheck',
    method: 'POST',
    data: obj,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          bulkPincodeCheckCallAction({
            bulkPincodeCheckRes: res.payload,
            errorBulkPincodeCheck: null
          })
        );
        toastr.removeByType('light');
        toastr.success('Success', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          bulkPincodeCheckCallAction({
            bulkPincodeCheckRes: null,
            errorBulkPincodeCheck:
              res.errorMessage || 'Bulk Pincode Information not available'
          })
        );
        toastr.removeByType('light');
        toastr.error('Error', res.errorMessage);
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('bulkPincodeCheckCallAction call failed ', res);
      dispatch(
        bulkPincodeCheckCallAction({
          bulkPincodeCheckRes: null,
          errorBulkPincodeCheck:
            res.errorMessage || 'Could not check Bulk Pincode'
        })
      );
      toastr.removeByType('light');
      toastr.error('Error', res.errorMessage || 'Could not check Bulk Pincode');
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in bulkPincodeCheckCallAction call', res);
      dispatch(
        bulkPincodeCheckCallAction({
          bulkPincodeCheckRes: null,
          errorBulkPincodeCheck: 'Could not check Bulk Pincode'
        })
      );
      toastr.removeByType('light');
      toastr.error('Error', 'Could not check Bulk Pincode');
    }
  };

  return makeApiCall(requestObj);
};
